<template>
  <div class="flex relative items-center">
    <div
      class="zt-switch relative inline-flex"
      :class="[classes]"
      v-bind="$attrs"
    >
      <input
        class="zt-switch-input absolute w-full h-full cursor-pointer opacity-0 select-none"
        type="checkbox"
        ref="ztCheckbox"
        :id="computerId"
        v-bind="$attrs"
        :disabled="$attrs.disabled"
        :value="checkboxValue"
        :checked="isChecked"
        v-on="listeners"
      />
      <div
        class="zt-switch--ripple absolute cursor-pointer"
        :class="textColorClasses"
      />
      <span
        class="zt-switch--track absolute pointer-events-none text-gray-500"
        :class="textColorClasses"
      />
      <div
        class="zt-switch--circle rounded-full absolute relative flex items-center justify-center text-white"
        :class="textColorClasses"
      />
    </div>
    <label
      class="zt-switch-label font-normal text-zt-lg cursor-pointer mb-0"
      :for="computerId"
      >{{ label }}</label
    >
  </div>
</template>

<script>
export default {
  name: 'ztSwitch',
  inheritAttrs: false,
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    value: {},
    flat: {
      type: Boolean,
      default: false
    },
    inset: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    label: {
      type: String,
      default: ''
    },
    inputValue: null
  },
  data() {
    return {
      checkboxValue: this.inputValue
    }
  },
  computed: {
    computerId() {
      return 'zt-switch-' + this._uid
    },
    listeners() {
      return {
        ...this.$listeners,
        change: event => {
          this.toggleValue(event)
        }
      }
    },
    classes() {
      return {
        'zt-switch--flat': this.flat,
        'zt-switch--inset': this.inset,
        'zt-switch--disabled': this.isDisabled
      }
    },
    textColorClasses() {
      if (this.checkboxValue && this.isChecked) {
        let colorLevel =
          this.color === 'primary' || this.color === 'secondary' ? '-200' : ''
        return `text-zt-${this.color + colorLevel}`
      } else {
        return null
      }
      /* purgecss:
       * text-zt-primary-100
       * text-zt-primary-200
       * text-zt-secondary-100
       * text-zt-secondary-200*/
    },
    internalValue: {
      get() {
        return this.checkboxValue
      },
      set(value) {
        this.checkboxValue = value
        this.$emit('input', this.checkboxValue)
      }
    },
    isChecked() {
      return Array.isArray(this.internalValue)
        ? this.isArrayIncludes()
        : this.internalValue
    },
    isDisabled() {
      return this.$attrs.disabled
    }
  },
  methods: {
    toggleValue() {
      if (this.$attrs.disabled) return
      let input = this.internalValue
      if (Array.isArray(input)) {
        const value = this.value.slice(0)
        const length = input.length
        if (this.isArrayIncludes()) {
          input.splice(input.indexOf(value), 1)
        }
        if (input.length === length) {
          input.push(value)
        }
      } else {
        input = !input
      }
      this.internalValue = input
      this.$emit('change', this.internalValue)
    },
    isArrayIncludes() {
      let model = this.internalValue
      let value = this.value
      return model.includes(value)
    }
  }
}
</script>

<style
  scoped
  lang="css"
  src="../../../../../src/styles/components/ztSwitch.css"
/>
